/**
 * Default image sizes for different use cases
 */
export const IMAGE_PRESETS = {
  playerThumbnail: {
    width: 100,
    height: 100,
    quality: 80
  },
  playerLarge: {
    width: 400,
    height: 400,
    quality: 85
  },
  teamLogo: {
    width: 100,
    height: 100,
    quality: 90
  }
} as const
